export enum MyActivitiesTypeEnum {
  EVENTS = 'Events',
  FITNESS = 'Fitness',
  MEETING_ROOM = 'Meeting Room',
  LOUNGE = 'Lounge',
  GYM = 'Gym',
  EVENT_SPACE = 'Event space',
  ROOF_TOP = 'Roof top',
}
